// @ts-nocheck

(() => {
  "use strict";

  const EL = (globalThis.EspacioLaserV2 =
    globalThis.EspacioLaserV2 || {});

  class EngravingScale {
    constructor({ state, elements }) {
      if (
        !state ||
        !elements?.object ||
        !elements?.scaleHandle
      ) {
        throw new Error(
          "[EspacioLaserV2] Scale requiere state, object y scaleHandle."
        );
      }

      this.state = state;
      this.object = elements.object;
      this.content =
        elements.content ||
        elements.previewText;
      this.handle = elements.scaleHandle;

      this.abortController =
        new AbortController();

      this.scaling = false;
      this.startDistance = 0;
      this.startScale = 1;

      this.bindEvents();
    }

    bindEvents() {
      const { signal } =
        this.abortController;

      this.handle.addEventListener(
        "pointerdown",
        (event) => this.start(event),
        { signal }
      );

      window.addEventListener(
        "pointermove",
        (event) => this.move(event),
        { signal }
      );

      window.addEventListener(
        "pointerup",
        () => this.end(),
        { signal }
      );

      window.addEventListener(
        "pointercancel",
        () => this.end(),
        { signal }
      );
    }

    start(event) {
      event.preventDefault();
      event.stopPropagation();

      const center = this.getCenter();

      this.startDistance =
        this.getDistance(
          center.x,
          center.y,
          event.clientX,
          event.clientY
        );

      this.startScale =
        Number(this.state.transform.scale) || 1;

      this.scaling = true;

      this.state.setUI("scaling", true);
      this.state.setUI("selected", true);

      if (this.handle.setPointerCapture) {
        this.handle.setPointerCapture(
          event.pointerId
        );
      }
    }

    move(event) {
      if (!this.scaling) return;

      event.preventDefault();

      const center = this.getCenter();

      const currentDistance =
        this.getDistance(
          center.x,
          center.y,
          event.clientX,
          event.clientY
        );

      if (this.startDistance <= 0) return;

      const ratio =
        currentDistance /
        this.startDistance;

      this.state.setScale(
        this.startScale * ratio
      );
    }

    end() {
      if (!this.scaling) return;

      this.scaling = false;

      this.state.setUI(
        "scaling",
        false
      );
    }

    getCenter() {
  const rect =
    this.object.getBoundingClientRect();

  return {
    x: rect.left + rect.width / 2,
    y: rect.top + rect.height / 2,
  };
}

    getDistance(
      centerX,
      centerY,
      pointerX,
      pointerY
    ) {
      return Math.hypot(
        pointerX - centerX,
        pointerY - centerY
      );
    }

    destroy() {
      this.abortController.abort();
    }
  }

  EL.EngravingScale =
    EngravingScale;
})();